module.exports = __webpack_public_path__ + "img/interface-screen-12.1cc459a.jpg";